<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10bBpJN/tc-custom/9781399081344.jpg?1720280502138" alt="This image is the cover for the book Kennedy Assassinations"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kennedy Assassinations
      </h1>
      <p class="bookDescription body article font2">
        <p>Few events have been the subject of more conspiracy theories than the assassinations of the two Kennedy brothers. Indeed, a great many people consider that there were other individuals than Lee Harvey Oswald and Sirhan Sirhan involved in both murders. Was a shot fired from Dealey Plaza’s grassy knoll? Why did Jack Ruby shoot Oswald? Was it the CIA, the Soviets, Cuban nationalists or the Mafia that arranged John Kennedy’s assassination? Was Robert Kennedy shot from in front and behind, and who had the most to gain from his death?  These are just a few of the questions that have been put forward by a myriad of conspiracy theorists and it is those people and their ideas that Mel Ayton has tackled head-on. Over many years, Mel Ayton has examined all the more substantial conspiracy theories and, through careful analysis of documents and eyewitness statements, he has demolished each one.  In each case, Mel Ayton presented the results of his detailed investigations in periodicals as he worked through the various theories. These have now been brought together to provide a comprehensive analysis of all the main theories as to who, how and why the two Kennedy brothers met their deaths in such unusual circumstances.  Though wild ideas will continue to be proposed and efforts will still be made to demonstrate that Oswald could not have fired off three shots with great accuracy in the few seconds available to him as the presidential cavalcade passed beneath the window where he crouched, or that there were sinister reasons why three CIA men were allegedly present on the night of Robert Kennedy’s assassination, the harsh reality is that the Kennedy brothers were each killed by lone gunmen.  This is an absorbing read, brought up to date with the addition of new material as it has been uncovered. Maybe, just maybe, this book will persuade people that the official accounts of both murders, although flawed, are not cover-ups but simply statements of fact.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mel Ayton
      </h2>
      
      <p class="authorDescription body article">Mel Ayton is the author of numerous books including "Hunting The President: Threats, Plots, And Assassination Attempts—From FDR To Obama” and “The Forgotten Terrorist: Sirhan Sirhan And The Assassination Of Robert F. Kennedy.” He has been a history consultant for The BBC, National Geographic Channel and Discovery Channel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Frontline Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d7c5b70